module.exports = __webpack_public_path__ + "src/assets/games/14/169.jpg";